import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { usePublicViewEntityContext } from '../../../context/PublicViewEntityProvider';

const GalleryTemplate = () => {
  const navigate = useNavigate();
  const { baseEntityUrl } = usePublicViewEntityContext();

  useEffect(() => navigate(baseEntityUrl), [baseEntityUrl, navigate]);
};

export default GalleryTemplate;
